import React from "react";

const TestimonialContext = React.createContext<any>({});

TestimonialContext.displayName = "Testimonial Context";

export default TestimonialContext;
